/**
 * @description 一个固定的ratio值
 */
export const $ratio = 750/640
/**
 * @description 一个固定的默认字体大小
 */
export const $browserDefaultFontSize = 14